import * as React from 'react';
import {connect} from "react-redux";
import {ApplicationState} from "../store";
import classNames from 'classnames';
import {
	AppBar,
	IconButton,
	Toolbar,
	withStyles, Menu, MenuItem, Badge
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/Notifications';
import {Tab, TabTypes} from "../tabs/Tab";
import {compose} from "redux";
import {GlobalStyles} from "../materialui/style";
import {actionCurrentUserFetch, actionExtendMainMenu, actionUserLogout} from "../store/global";
import {User} from "../models/User";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import {TabsService} from "../tabs/TabsService";
import {t} from '../core/localization';
import {Notification} from "../models/Notification";
import Tooltip from '@material-ui/core/Tooltip';

export interface ApplicationBarProps {
	activeTab: Tab,
	mainMenuExtended: boolean,
	classes: any
	currentUser: User
	allNotifications: Notification[]
}

export interface ApplicationBarState {
	dropdownOpen: boolean,
	anchorEl: any
}

function mapStateToProps(state: ApplicationState) {
	return {
		mainMenuExtended: state.global.mainMenuOpened,
		activeTab: state.tabs.active,
		currentUser: state.global.currentUser,
		allNotifications: state.notifications.list
	};
}

class ApplicationBar extends React.Component<ApplicationBarProps, ApplicationBarState> {

	constructor(props: ApplicationBarProps) {
		super(props)

		this.state = {
			dropdownOpen: false,
			anchorEl: null
		}
	}

	componentDidMount() {
		actionCurrentUserFetch()
	}


	render(): React.ReactNode {

		let classes = this.props.classes
		let firstName = this.props.currentUser ? this.props.currentUser.firstName : ''
		let lastName = this.props.currentUser ? this.props.currentUser.lastName : ''

		let unseen = 0
		let allNotifications: Notification[] = this.props.allNotifications
		for (let i=0; i<allNotifications.length; i++){
			if (!allNotifications[i].seen)
				unseen++
		}

		return (
			<AppBar
				position="absolute"
				className={classNames(classes.appBar, this.props.mainMenuExtended && classes.appBarShift)}
			>
				<Toolbar disableGutters={!this.props.mainMenuExtended} className={classes.toolbar}>
					<IconButton
						color="inherit"
						aria-label="Open drawer"
						onClick={this.handleDrawerOpen}
						className={classNames(
							classes.menuButton,
							this.props.mainMenuExtended && classes.menuButtonHidden,
						)}
					>
						<MenuIcon />
					</IconButton>
					<div className={'ev-appbar-left-controls'} style={{width: '100%'}}>
						<div style={{float: 'right', position: 'relative'}}>
							<IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={this.openDropdown.bind(this)}>
								<ArrowDropDownIcon style={{ color: '#fff'}} />
							</IconButton>
							<Menu
								id="primary-search-account-menu"
								keepMounted
								open={this.state.dropdownOpen}
								onClose={this.closeDropdown.bind(this)}
								transformOrigin={{ vertical: 'top', horizontal: 'right' }}
								anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
								anchorEl={this.state.anchorEl}
							>
								<MenuItem onClick={this.onProfileClick.bind(this)}>Profile</MenuItem>
								<MenuItem onClick={this.onLogout}>Logout</MenuItem>
							</Menu>
						</div>
						<div style={{float: 'right'}} className={'ev-username'}>{firstName} {lastName}</div>
						<Tooltip title={t.Notifications}>
							<IconButton color="inherit" style={{float: 'right', marginRight: '5px'}}
							onClick={() => {TabsService.createTab(t.Notification, TabTypes.NOTIFICATIONS)}}>
								<Badge badgeContent={unseen} color="secondary" showZero>
									<NotificationsIcon />
								</Badge>
							</IconButton>
						</Tooltip>
					</div>
				</Toolbar>
			</AppBar>
		);
	}

	openDropdown(event: any) {
		console.log('event: ', event);
		this.setState({dropdownOpen: true, anchorEl: event.currentTarget});
	}

	closeDropdown() {
		this.setState({dropdownOpen: false, anchorEl: null});
	}

	onProfileClick(){
		const user = this.props.currentUser;
		TabsService.createTab('User: ' + user.firstName, TabTypes.USERS_NEW, user);
		this.setState({dropdownOpen: false, anchorEl: null});
	}

	private handleDrawerOpen = () => {
		actionExtendMainMenu()
	};

	onLogout () {
		actionUserLogout()
	}

}

export default compose(
	connect(mapStateToProps),
	withStyles(GlobalStyles)
)(ApplicationBar);
